import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearMultipleData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useMenuList() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveMenuListMasterStatus = getStatus(state, apiKeys.saveMenuListMaster, '');
  const updateMenuListMasterStatus = getStatus(state, apiKeys.updateMenuListMaster, '');
  const menuListData = getData(state, apiKeys.menuList, []);
  const menuListStatus = getStatus(state, apiKeys.menuList, '');
  const menuListErrMsg = getErrorMessage(state, apiKeys.menuList, '');
  const deleteMenuListStatus = getStatus(state, apiKeys.deleteMenuList, '');


  const getMenuList = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.menuList,
      method: apiMethods.GET,
      key: apiKeys.menuList,
      failureMsg: formatMessage({ id: "failed-to-get-menu-list" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getMenuList()
  }, [dispatch, getMenuList]);

  useEffect(() => {
    if (deleteMenuListStatus === apiStatuses.succeeded) {
      getMenuList();
    }
  }, [deleteMenuListStatus, getMenuList])

  useEffect(() => () => {
    dispatch(clearMultipleData({ key:[ apiKeys.menuList, apiKeys.saveMenuListMaster,
       apiKeys.deleteMenuList]  }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  useEffect(() => {
    if (saveMenuListMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getMenuList();
    } 
  }, [saveMenuListMasterStatus, closeModal, getMenuList]);

  useEffect(() => {
    if (updateMenuListMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getMenuList();
    } 
  }, [updateMenuListMasterStatus, closeModal, getMenuList]);

  return useMemo(() => ({
    menuListData,
    menuListStatus,
    menuListErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    menuListData,
    menuListStatus,
    menuListErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
